import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {Injectable} from "@angular/core";
import {SimpleDate} from "../utils/simple-date";

export enum EventType {
  RESERVATION_CONFIRMED = 'RESERVATION_CONFIRMED',
  RESERVATION_WAITING = 'RESERVATION_WAITING',
  DISPOSAL_AVAILABLE = 'DISPOSAL_AVAILABLE',
  DISPOSAL_NOT_AVAILABLE = 'DISPOSAL_NOT_AVAILABLE'
}

export interface Event {
  readonly title: string;
  readonly start: Date;
  readonly end: Date;
  readonly origin_id: number;
  readonly type: EventType;
}

@Injectable()
export class EventsService {

  constructor(private http: HttpClient) {
  }

  getEvents(start: SimpleDate, end: SimpleDate): Observable<Event[]> {
    return this.http.get<Event[]>('/disposals/events', {
      params: {
        'start': start.toJSON(),
        'end': end.toJSON(),
      }
    })
  }


}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/services/events.service.ts